/**
 * Date utility functions for Kuwait date format (dd/mm/yyyy)
 */

/**
 * Convert date from yyyy-mm-dd to dd/mm/yyyy
 */
export function convertToKuwaitFormat(isoDate) {
  if (!isoDate) return '';
  
  try {
    const parts = isoDate.split('-');
    if (parts.length === 3) {
      const [year, month, day] = parts;
      return `${day}/${month}/${year}`;
    }
    return isoDate;
  } catch (error) {
    console.error('Error converting date to Kuwait format:', error);
    return isoDate;
  }
}

/**
 * Convert date from dd/mm/yyyy to yyyy-mm-dd (ISO format)
 */
export function convertFromKuwaitFormat(kuwaitDate) {
  if (!kuwaitDate) return '';
  
  try {
    const parts = kuwaitDate.split('/');
    if (parts.length === 3) {
      const [day, month, year] = parts;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return kuwaitDate;
  } catch (error) {
    console.error('Error converting date from Kuwait format:', error);
    return kuwaitDate;
  }
}

/**
 * Format date object to dd/mm/yyyy
 */
export function formatDateToKuwait(date) {
  if (!date) return '';
  
  try {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
}

/**
 * Get today's date in yyyy-mm-dd format for max date validation
 */
export function getTodayISO() {
  const today = new Date();
  return today.toISOString().split('T')[0];
}

/**
 * Get date 16 years ago (minimum age) in yyyy-mm-dd format
 */
export function getMinAgeDate() {
  const today = new Date();
  today.setFullYear(today.getFullYear() - 16);
  return today.toISOString().split('T')[0];
}

/**
 * Validate Kuwait date format (dd/mm/yyyy)
 */
export function isValidKuwaitDate(dateStr) {
  if (!dateStr) return false;
  
  const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
  const match = dateStr.match(regex);
  
  if (!match) return false;
  
  const [, day, month, year] = match;
  const d = parseInt(day, 10);
  const m = parseInt(month, 10);
  const y = parseInt(year, 10);
  
  // Check valid ranges
  if (m < 1 || m > 12) return false;
  if (d < 1 || d > 31) return false;
  
  // Check valid date
  const date = new Date(y, m - 1, d);
  return date.getFullYear() === y && date.getMonth() === m - 1 && date.getDate() === d;
}
